export default __webpack_public_path__ + "static/media/after-laughter.7b3471fd.jpg";